import { API } from "../utils";

export const getLetters = async ({ params }) =>
  API.get("/organization/letters", { params });

export const getLetter = async ({ params }) =>
  API.get(`/organization/letters/${params.uuid}`);

export const createLetter = async ({ body }) =>
  API.post("/organization/letters", body, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 120000,
  });

export const updateLetter = async ({ params, body }) =>
  API.post(`/organization/letters/${params.uuid}/update`, body, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 120000,
  });

export const transitionLetter = async ({ params, body }) =>
  API.post(`/organization/letters/${params.uuid}/transition`, body);

export const referLetter = async ({ params, body }) =>
  API.post(`/organization/letters/${params.uuid}/refer`, body);

export const actOnLetter = async ({ params }) =>
  API.post(`/organization/letters/${params.uuid}/act`);

export const deleteLetter = async ({ params }) =>
  API.delete(`/organization/letters/${params.uuid}`);

export const deleteLetterMedia = async ({ params }) =>
  API.delete(
    `/organization/letters/${params.uuid}/media/${params.mediaUuid}`,
  );

export const getLetterActivities = async ({ params }) =>
  API.get(`/organization/letters/${params.uuid}/activities`, { params });

export const getLettersExcel = async ({ params }) =>
  API.get("/organization/letters/excel/export", { params });
